import { DomainSchema } from "@/schemas/domain.schema"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table"
import { z } from "zod"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { ToggleInput, ToggleLabel, ToggleSpan } from "./ui/toggle"
import DeleteCompanyModal from "./deleteCompany/DeleteCompanyModal"
import { Button } from "./ui/button"

interface Props {
    domains: z.infer<typeof DomainSchema>[]
}

export default function DomainsTable(props: Props) {

    const navigate = useNavigate();

    const goToDomainDetailsPage = (domainId: string, companyId: string) => {
        navigate(`/companies/${companyId}/domains/${domainId}`);
    }

    const [hideTestDomains, setHideTestDomains] = useState(false);
    const [currentDomains, setCurrentDomains] = useState<z.infer<typeof DomainSchema>[]>([]);

    function HideTestDomains(){
        setHideTestDomains(!hideTestDomains);
        const domains = props.domains.filter(d => {
            // We invert the value in the checks, since the flip through 'setHideTestDomains' haven't registered yet
            if(!hideTestDomains == true && d.TestDomain == false){
                return d;
            } else if(!hideTestDomains == false){
                return d;
            }
        });

        setCurrentDomains(domains);
    }

    useEffect(() => {
        if(currentDomains.length === 0){
            setCurrentDomains(props.domains);
        }
    }, [props.domains, currentDomains]);

    return (
        <div>
            <div className="flex items-center justify-between mt-2">
                <div className="w-[200px]">
                    <ToggleLabel className="ps-0">
                        <span>
                            Hide test domains:
                        </span>
                        <ToggleInput checked={hideTestDomains} onChange={() => HideTestDomains()} className="w-sm"/>
                        <ToggleSpan/>
                    </ToggleLabel>
                </div>
                <DeleteCompanyModal updateData={() => {}} />
            </div>
            <div className="flex items-center justify-between mt-2">
                <p>Total Domains: {props.domains.length}</p>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Website</TableHead>
                        <TableHead>Folder</TableHead>
                        <TableHead>Actions</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {currentDomains?.map((domain) => (
                        <TableRow key={domain.ID}>
                            <TableCell>{domain.Name}</TableCell>
                            <TableCell>{domain.Website}</TableCell>
                            <TableCell>{domain.Folder}</TableCell>
                            <TableCell><Button onClick={() => window.open("https://clearbook.dk/".concat(domain.Folder), '_blank')}>Link</Button></TableCell>
                            <TableCell onClick={() => goToDomainDetailsPage(domain.ID, domain.CompanyID)} className="cursor-pointer">Actions</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {currentDomains.length <= 0 && (
                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                    <p>No domains available</p>
                </div>
            )}
        </div>
    )
}